import { EnumWithDescription, ICustomEnumValue } from "./EnumWithDescription";

export enum HuvSfvTaskStatusEnum {
    "Not Yet Due" = 1,
    "Not Yet Started" = 2,
    "Saved" = 3,
    "Completed" = 11,
    "Pending Addendum" = 16,
    "Not Yet Scheduled" = 20
}

export class HuvSfvTaskStatusClass extends EnumWithDescription<HuvSfvTaskStatusEnum> {
    public readonly enum = HuvSfvTaskStatusEnum;
    public readonly enumName: string = "HuvSfvTaskStatusEnum";
    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<HuvSfvTaskStatusEnum>> = new Map([
        [
            "Not Yet Due",
            {
                name: "Not Yet Due",
                value: 1
            }
        ],
        [
            "Not Yet Started",
            {
                name: "Not Yet Started",
                value: 2
            }
        ],
        [
            "Saved",
            {
                name: "Saved",
                value: 3
            }
        ],
        [
            "Completed",
            {
                name: "Completed",
                value: 11
            }
        ],
        [
            "Pending Addendum",
            {
                name: "Pending Addendum",
                value: 16
            }
        ],
        [
            "Not Yet Scheduled",
            {
                name: "Not Yet Scheduled",
                value: 20
            }
        ]
    ]);
}

export const HuvSfvTaskStatus = new HuvSfvTaskStatusClass();
